<template>
  <div class="bg-surface-primary rounded-4xl py-xl px-l flex flex-col gap-l h-full">
    <div class="h-44 w-full flex items-center justify-center">
      <Skeleton class="h-full w-32 bg-carbon-200 rounded-2xl" />
    </div>
    <div class="flex flex-col text-center gap-s">
      <Skeleton class="w-2/3 h-6 bg-carbon-200 rounded mx-auto" />
      <Skeleton class="w-1/2 h-4 bg-carbon-100 rounded mx-auto" />
    </div>
  </div>
</template>
